const binding = { modules: {}, dataActions: {} };

    (binding.modules['cz-back-top-footer'] = {
        c: () => require('partner/modules/cz-back-top-footer/cz-back-top-footer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cz-back-top-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cz-back-top-footer'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };